import React, { useState, useEffect, useRef } from "react";
import {
  makeStyles,
  Button,
  Grid,
  TextField,
  Snackbar,
} from "@material-ui/core";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import closeSvg from "../../assets/svg/delete.svg";

import { resetPasswordByOldPassword } from "../../actions/password";

const useStyles = makeStyles({
  box: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: (width) => {
      return width + "px";
    },
    background: "#fff",
    boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.2)",
    borderRadius: "4px",
  },
  title: {
    width: "100%",
    height: "48px",
    padding: "0 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e9e9e9",
    fontSize: "16px !important",
    color: "#666",
    boxSizing: "border-box",
    "& img": {
      cursor: "pointer",
    },
  },
  content: {
    width: "100%",
    padding: "18px 30px 20px 30px",
    boxSizing: "border-box",
  },
  input: {
    flex: "1",
    "& input": {
      height: "40px",
      padding: "0 15px",
      border: "1px solid #d9d9d9",
      fontSize: "16px",
      color: "#000",
      boxSizing: "border-box",
      borderRadius: "2px",
      outline: "none",
      "&::-webkit-input-placeholder": {
        color: "#999",
      },
    },
    "& .MuiFormHelperText-root": {
      position: "absolute",
      bottom: "-24px",
      margin: "0 !important",
    },
  },
  formItem: {
    width: "100%",
    marginBottom: "24px !important",
    display: "flex",
    flexFlow: "row",
    flexDirection: "row !important",
    alignItems: "center",
    "& label": {
      width: "84px",
      textAlign: "right",
    },
  },
  footer: {
    padding: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    borderTop: "1px solid #ddd",
  },
  btn: {
    width: "82px",
    height: "34px",
    marginLeft: "14px",
    borderRadius: "2px",
    background: "#3276C3",
  },
  defaultBtn: {
    width: "82px",
    height: "34px",
    padding: "0 !important",
    border: "1px solid #d9d9d9 !important",
    borderRadius: "2px",
    backgroundColor: "#fff !important",
    color: "rgba(0, 0, 0, .65) !important",
    fontSize: "14px",
    boxShadow: "none !important",
    "&.first": {
      marginRight: "10px",
    },
  },
});
export default function PasswordModal(props) {
  const { submit, close, width } = props;
  const classes = useStyles(width);

  const [form, setForm] = useState({
    password: "",
    newPassword: "",
    newPassword2: "",
  });

  const [formError, setFormError] = useState({
    error1: false,
    error2: false,
    error3: false,
  });

  useEffect(() => {}, []);

  const inputRef = useRef();

  const changeInput = (e) => {
    let newForm = Object.assign({}, form);
    newForm[e.target.name] = e.target.value;
    setForm(newForm);
  };

  const newPasswordBlur = (e) => {
    let newFormError = Object.assign({}, formError);
    newFormError.error2 =
      !/^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/.test(
        e.target.value
      );
    if (e.target.value == form.password) {
      newFormError.error2 = true;
    }
    setFormError(newFormError);
  };
  const newPassword2Blur = (e) => {
    let newFormError = Object.assign({}, formError);
    newFormError.error3 = e.target.value != form.newPassword;
    setFormError(newFormError);
  };

  const inputFocus = (e, key) => {
    let newFormError = Object.assign({}, formError);
    newFormError[key] = false;
    setFormError(newFormError);
  };

  const confirm = () => {
    let newFormError = Object.assign({}, formError);
    let errorFlag = false;
    if (form.password == "") {
      newFormError.error1 = true;
      errorFlag = true;
    }
    if (form.newPassword == "") {
      newFormError.error2 = true;
      errorFlag = true;
    }
    if (form.newPassword2 == "") {
      newFormError.error3 = true;
      errorFlag = true;
    }
    setFormError(newFormError);
    if (errorFlag) {
      return;
    }
    submitModifyPassword();
  };

  const submitModifyPassword = () => {
    let password = form.password;
    let newPassword = form.newPassword;
    let data = { password, newPassword };
    resetPasswordByOldPassword(data)
      .then((res) => submit())
      .catch(() => {
        let newFormError = Object.assign({}, formError);
        newFormError.error1 = true;
        setFormError(newFormError);
      });
  };

  return (
    <Grid className={classes.box}>
      <Typography className={classes.title}>
        <Typography variant="span">修改密码</Typography>
        <Typography variant="span" onClick={() => close()}>
          <img src={closeSvg} />
        </Typography>
      </Typography>

      <Grid className={classes.content}>
        <Grid className={classes.form}>
          <FormControl className={classes.formItem}>
            <FormLabel id="passwordLabel">原密码：</FormLabel>
            <TextField
              type="password"
              error={formError.error1}
              helperText={formError.error1 ? "原密码不正确" : ""}
              placeholder="请输入原密码"
              aria-labelledby="passwordLabel"
              name="password"
              className={classes.input}
              variant="outlined"
              onChange={changeInput}
              onFocus={(e) => inputFocus(e, "error1")}
            />
          </FormControl>
          <FormControl className={classes.formItem}>
            <FormLabel id="newPasswordLabel">新密码：</FormLabel>
            <TextField
              type="password"
              error={formError.error2}
              helperText={
                formError.error2
                  ? "至少6位,包含1个大写字母，1个小写字母，1个数字，1个特殊字符，非原密码"
                  : ""
              }
              placeholder="请输入新密码"
              aria-labelledby="newPasswordLabel"
              name="newPassword"
              className={classes.input}
              variant="outlined"
              onChange={changeInput}
              onFocus={(e) => inputFocus(e, "error2")}
              onBlur={newPasswordBlur}
            />
          </FormControl>
          <FormControl className={classes.formItem}>
            <FormLabel id="newPasswordLabel2">确认密码：</FormLabel>
            <TextField
              type="password"
              error={formError.error3}
              helperText={formError.error3 ? "输入有误，密码不匹配" : ""}
              placeholder="请再次输入密码"
              aria-labelledby="newPasswordLabel2"
              name="newPassword2"
              className={classes.input}
              variant="outlined"
              onChange={changeInput}
              onBlur={newPassword2Blur}
              onFocus={(e) => inputFocus(e, "error3")}
            />
          </FormControl>
        </Grid>
      </Grid>

      <Grid className={classes.footer}>
        <Button
          onClick={close}
          className={classes.defaultBtn}
          variant="contained"
        >
          {" "}
          取消
        </Button>
        <Button
          onClick={confirm}
          className={classes.btn}
          variant="contained"
          color="primary"
          disabled={formError.error1 || formError.error2 || formError.error3}
        >
          {" "}
          修改
        </Button>
      </Grid>
    </Grid>
  );
}
